import { z } from 'zod';

const documentSchema = z.object({
  type: z.string().optional().nullable(),
  referenceNumber: z.string().optional().nullable(),
});

const additionalInformationSchema = z.object({
  code: z.string().optional().nullable(),
  text: z.string().optional().nullable(),
});

const additionalFiscalReferenceSchema = z.object({
  role: z.string().optional().nullable(),
  vatIdentificationNumber: z.string().optional().nullable(),
});

export const declarationViewGoodLVSchema = z.object({
  _id: z.string().optional().nullable(),
  documents: z
    .object({
      previousDocuments: z.array(documentSchema).optional().nullable(),
      supportingDocuments: z.array(documentSchema).optional().nullable(),
      additionalReference: z.array(documentSchema).optional().nullable(),
      additionalInformation: z.array(additionalInformationSchema).optional().nullable(),
      additionalFiscalReference: z.array(additionalFiscalReferenceSchema).optional().nullable(),
      transportDocuments: z.array(documentSchema).optional().nullable(),
    })
    .optional()
    .nullable(),
});

export type DeclarationViewGoodLVFormValues = z.infer<typeof declarationViewGoodLVSchema>;
